const drpDownUpgraded = () => {
    $(document).ready(() => {
        ($('.CategorySelect') as any).chosen({
            allow_single_deselect: true,
            rtl: true,
            inherit_select_classes: true,
            no_results_text: 'موردی یافت نشد',
            search_contains: false,
            placeholder_text_single: 'یکی از موارد زیر را انتخاب کنید.'
        });
        ($('.BrandSelect') as any).chosen({
            allow_single_deselect: true,
            rtl: true,
            inherit_select_classes: true,
            no_results_text: 'موردی یافت نشد',
            search_contains: false,
            placeholder_text_single: 'یکی از موارد زیر را انتخاب کنید.'
        });
        ($('.GuaranteeSelect') as any).chosen({
            allow_single_deselect: true,
            rtl: true,
            inherit_select_classes: true,
            no_results_text: 'موردی یافت نشد',
            search_contains: false,
            placeholder_text_single: 'یکی از موارد زیر را انتخاب کنید.'
        });
        ($('.ColorSelect') as any).chosen({
            allow_single_deselect: true,
            rtl: true,
            inherit_select_classes: true,
            no_results_text: 'موردی یافت نشد',
            search_contains: false,
            placeholder_text_single: 'یکی از موارد زیر را انتخاب کنید.'
        });
        ($('.UpdatorSelect') as any).chosen({
            allow_single_deselect: true,
            rtl: true,
            inherit_select_classes: true,
            no_results_text: 'موردی یافت نشد',
            search_contains: false,
            placeholder_text_single: 'یکی از موارد زیر را انتخاب کنید.'
        });
        ($('.UserSelect') as any).chosen({
            allow_single_deselect: true,
            rtl: true,
            inherit_select_classes: true,
            no_results_text: 'موردی یافت نشد',
            search_contains: false,
            placeholder_text_single: 'یکی از موارد زیر را انتخاب کنید.'
        });
        ($('.ProductMutipleFeatures') as any).chosen({
            allow_single_deselect: true,
            rtl: true,
            inherit_select_classes: true,
            no_results_text: 'موردی یافت نشد',
            search_contains: false,
            placeholder_text_multiple: 'موارد مورد نظر را انتخاب کنید.',
            hide_results_on_select: false
        });
    })
}

export {
    drpDownUpgraded
}